import { CHANGE_MENU_PATH } from '../actions/menu';
import classes from '../../components/NavBar/navBar.module.scss';
import { ReactComponent as DashboardIcon } from '../../assets/icons/dashboard.svg';
import { ReactComponent as ScriptIcon } from '../../assets/icons/script.svg';
import { ReactComponent as PatientIcon } from '../../assets/icons/patient.svg';
import { ReactComponent as AgendaIcon } from '../../assets/icons/agenda.svg';
import { ReactComponent as PhysicianIcon } from '../../assets/icons/physician.svg';
import { ReactComponent as RefileIcon } from '../../assets/icons/refile.svg';
import { ReactComponent as ProductIcon } from '../../assets/icons/product.svg';
import { ReactComponent as TeamIcon } from '../../assets/icons/team.svg';
import { ReactComponent as ReportIcon } from '../../assets/icons/report.svg';
import { ReactComponent as HealthPlanIcon } from '../../assets/icons/health_plan.svg';

const menu = [
  {
    path: sessionStorage.getItem('Scripts') || '/scripts',
    icon: <ScriptIcon className={classes.script} />,
    name: 'Scripts',
  },
  {
    path: sessionStorage.getItem('Patients') || '/patients',
    icon: <PatientIcon />,
    name: 'Patients',
  },
  {
    path: sessionStorage.getItem('Agenda') || '/agenda',
    icon: <AgendaIcon className={classes.agenda} />,
    name: 'Agenda',
  },
  {
    path: sessionStorage.getItem('Dashboard') || '/dashboard',
    icon: <DashboardIcon />,
    name: 'Dashboard',
  },
  {
    path: sessionStorage.getItem('Physicians') || '/physicians',
    icon: <PhysicianIcon />,
    name: 'Physicians',
  },
  {
    path: sessionStorage.getItem('Health') || '/health',
    icon: <HealthPlanIcon />,
    name: 'Health Plans',
  },
  {
    path: sessionStorage.getItem('Refills') || '/refills',
    icon: <RefileIcon />,
    name: 'Refills',
  },
  {
    path: sessionStorage.getItem('Products') || '/products',
    icon: <ProductIcon />,
    name: 'Products',
  },
  {
    path: sessionStorage.getItem('Reports') || '/reports',
    icon: <ReportIcon />,
    name: 'Reports',
  },
  {
    path: sessionStorage.getItem('My Team') || '/team',
    icon: <TeamIcon />,
    name: 'My Team',
  },
  // {
  //   path: sessionStorage.getItem('Possible persons') || '/possible-persons',
  //   icon: <PossiblePersonIcon />,
  //   name: 'Possible persons',
  // },
];

const initialState = {
  menu,
};

export default function reducer(state = initialState, { payload, type }) {
  switch (type) {
    case CHANGE_MENU_PATH:
      return {
        ...state,
        menu: state.menu.map((m) => (m.name === payload.name ? { ...m, path: payload.path } : m)),
      };

    default: {
      return state;
    }
  }
}
